import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Ladder } from 'src/models/ladder.model';

@Injectable({
   providedIn: 'root',
})
export class RecordService {
   constructor(private http: HttpClient) { }
  recordMatch(m): Observable<any> {
    delete m.opponentId
    return this.http.post<any>(`/match/record`, m);
  }
  recordMatchTournament(m): Observable<any> {
    delete m.opponentId
    return this.http.post<any>(`/match/record/tournament`, m);
  }
   ladderInfo(): Observable<Ladder> {
      return this.http.get<Ladder>(`/ladder/info`);
   }

}

